import angular from 'angular';
import salesHomeComponent from './sales-home.component';
import SalesHomeService from './sales-home.service';
// import salesHomeConfig from './sales-home.config';

let salesHomeModule = angular.module('app.salesHome',[])
  .component('salesHome', salesHomeComponent)
  .service('SalesHomeService', SalesHomeService);
  // .config(salesHomeConfig);

export default salesHomeModule;



/** WEBPACK FOOTER **
 ** ./www/components/sales-home/sales-home.js
 **/